<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-space-between mb-5">
          <h6 class="text-h6 font-weight-bold">
            {{ $t("label.author_info") }}
          </h6>
          <v-menu v-if="!readonly" rounded offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="success" outlined>
                투고 논문 저자 불러오기
              </v-btn>
            </template>

            <v-list v-if="previousAuthors.length > 0">
              <v-list-item
                link
                v-for="(author, index) in previousAuthors"
                :key="index"
                @click="selectPreviousAuthor(author)"
              >
                <v-list-item-title>{{
                  `${author.full_name} (${author.organization})`
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list v-else>
              <v-list-item>
                <v-list-item-title>
                  불러올 데이터가 없습니다.
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-card v-for="(author, index) in localData" :key="index" class="mb-4">
          <v-card-text>
            <v-row>
              <v-col>
                <v-select
                  v-model="author.author_type"
                  :items="authorTypeOptions"
                  :label="$t('label.author_type')"
                  :item-value="(item) => item.key"
                  :item-text="(item) => item.label"
                  :readonly="readonly"
                  required
                  outlined
                  dense
                  hide-details="auto"
                ></v-select>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.given_name"
                  :label="$t('label.author_given_name')"
                  :readonly="readonly"
                  outlined
                  required
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.surname"
                  :label="$t('label.author_surname')"
                  :readonly="readonly"
                  outlined
                  required
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.full_name"
                  :label="$t('label.author_full_name')"
                  :readonly="readonly"
                  outlined
                  required
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.name_eng"
                  :label="$t('label.author_name_eng')"
                  :readonly="readonly"
                  outlined
                  required
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-text-field
                  v-model="author.email"
                  :label="$t('label.author_email')"
                  :readonly="readonly"
                  outlined
                  required
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.organization"
                  :label="$t('label.author_organization')"
                  :readonly="readonly"
                  outlined
                  required
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.organization_eng"
                  :label="$t('label.author_organization_eng')"
                  :readonly="readonly"
                  outlined
                  required
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.department"
                  :label="$t('label.author_department')"
                  :readonly="readonly"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-text-field
                  v-model="author.position"
                  :label="$t('label.author_position')"
                  :readonly="readonly"
                  outlined
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-col>

              <v-col cols="1" class="d-flex justify-end align-center">
                <v-btn
                  v-if="!readonly"
                  color="blue-grey white--text"
                  elevation="0"
                  fab
                  small
                  class="mr-2"
                  @click="handleUpdate(author)"
                >
                  <v-icon small>mdi-content-save-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="!readonly"
                  color="red white--text"
                  elevation="0"
                  small
                  fab
                  @click="handleDelete(author, index)"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-row v-if="localData.length === 0">
          <v-col>
            <v-sheet
              class="pa-3 text-center"
              fill
              color="primary lighten-2"
              rounded
            >
              <v-icon class="ma-2">mdi-information-outline</v-icon>
              <span class="text-subtitle-1 font-weight-light">{{
                $t("txt.data_empty")
              }}</span>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn
              v-if="!readonly"
              color="grey lighten-3"
              class="mt-2 mb-2 grey--text"
              elevation="0"
              block
              @click="handleAdd"
            >
              {{ $t("button.add") }}
              <v-icon size="small" class="ml-2">mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- 하단 버튼 영역 -->
        <v-row class="mt-12">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              v-if="!readonly"
              color="grey darken-3"
              rounded
              large
              elevation="0"
              dark
              @click="handleClose"
            >
              {{ $t("button.close") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authorTypeOptions } from "@/fields/paper/fields";
import { savePopup, deletePopup, closePopup } from "@/fields/paper/popups";

import { authorApi } from "@/api/api";

export default {
  name: "submit-author",
  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    authors: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      localData: [...this.authors],
      authorTypeOptions: authorTypeOptions,
      previousAuthors: [],
    };
  },
  methods: {
    /***************************************************************************************
     * 버튼 액션
     ***************************************************************************************/
    /**
     * 뒤로가기
     */
    toSubmissionStatus() {
      this.$router.push({
        name: "submission-status",
      });
    },
    selectPreviousAuthor(author) {
      this.localData.push({
        idx: null,
        given_name: author.given_name,
        surname: author.surname,
        full_name: author.full_name,
        name_eng: author.name_eng,
        email: author.email,
        organization: author.organization,
        organization_eng: author.organization_eng,
        department: author.department,
        position: author.position,
        author_type: "default",
      });
    },
    /**
     * 저자 정보 수정 버튼 액션
     */
    async handleUpdate(author) {
      if (
        author.author_type === "default" ||
        author.given_name === "" ||
        author.surname === "" ||
        author.full_name === "" ||
        author.name_eng === "" ||
        author.email === "" ||
        author.organization === "" ||
        author.organization_eng === ""
      ) {
        this.notifyVue({
          message: this.$t("alert.invalid_form"),
          style: "danger",
        });
        return;
      }

      const isConfirmed = await savePopup();

      if (!isConfirmed) {
        return;
      }

      if (author.idx === null) {
        this.$emit("add", author);
      } else {
        this.$emit("update", author);
      }
    },

    /**
     * 저자 삭제 액션
     */
    async handleDelete(author, index) {
      const isConfirmed = await deletePopup();

      if (!isConfirmed) {
        return;
      }

      if (author.idx == null) {
        this.localData.splice(index, 1);
        return;
      }
      this.$emit("delete", author);
    },

    /**
     * 저자 추가 액션
     */
    async handleAdd() {
      this.localData.push({
        idx: null,
        given_name: "",
        surname: "",
        full_name: "",
        name_eng: "",
        email: "",
        organization: "",
        department: "",
        position: "",
        paper_idx: this.paperIdx,
        author_type: "default",
      });
    },

    /**
     * 뒤로가기 액션
     */
    async handleClose() {
      if (this.readonly) {
        this.toSubmissionStatus();
        return;
      }

      const isConfirmed = await closePopup();

      if (!isConfirmed) {
        return;
      }

      this.toSubmissionStatus();
    },
    /***************************************************************************************
     * API 호출
     ***************************************************************************************/
    // 이전 저자 정보 조회
    async fetchPreviousAuthors() {
      try {
        const response = await authorApi.getPreviousAuthors();
        if (response && response.status === 200) {
          this.previousAuthors = response.data.response;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      }
    },
    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  async mounted() {
    await this.fetchPreviousAuthors();
  },
  watch: {
    authors: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.localData = JSON.parse(JSON.stringify(newValue));
      },
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
